module.exports = __webpack_public_path__ + "media/img/oc_image_1-4d4b72e5.png";